import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AlarisComplexTooltipDirective, AlarisRadioComponent } from '@campaign-portal/components-library';
import { TranslateModule } from '@ngx-translate/core';
import { MessagePurpose } from '@campaign-portal/namespace/common/enums';
import { ViberPriorityComponent } from '../viber-priority';
import { FormControl } from '@angular/forms';

@Component({
	selector: 'app-message-purposes',
	imports: [AlarisRadioComponent, TranslateModule, AlarisComplexTooltipDirective],
	templateUrl: './message-purposes.component.html',
	styleUrl: './message-purposes.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagePurposesComponent {
	@Input() control = new FormControl();

	protected readonly MessagePurpose = MessagePurpose;
	protected readonly tooltipPriorityComponent = ViberPriorityComponent;
}
